<template>
  <div class="sidebar">
    <div class="sidebar-sticky">
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-link
            class="nav-link font-weight-bolder text-aegis-dk"
            :to="{ name: 'home' }"
            exact
          >
            AEGIS home
          </b-link>
        </li>
      </ul>

      <hr>
      <ul class="nav flex-column">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-chart-bar"></i>
            MAIN
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'dashboard' }" exact>
            Dashboard
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'uploads' }" exact>
            Uploads
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'public-documents' }" exact>
            General Team Documents
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['Data Manager'])">
          <b-link class="nav-link" :to="{ name: 'subject-photos' }" exact>
            Subject Photos
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['DSMB', 'Study Statistician', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'analysis' }" exact>
            Analysis
          </b-link>
        </li>
        <!-- <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'test' }" exact>
            Test
          </b-link>
        </li> -->
      </ul>

      <!-- Report -->
      <hr v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement', 'Subject Final Status Workflow Editor'])" />
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement', 'Subject Final Status Workflow Editor'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Report
          </b-dropdown-header>
        </li>
        <!-- Summary Slide with date range -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'summary-slide-report' }">
            Summary Slide
          </b-link>
        </li>
        <!-- SR Coverage Indicators -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'sr-coverage-indicators-report' }">
            SR Coverage Indicators
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Product Preparation'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Product Preparation'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-tasks"></i>
            Product Bag Utilities
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'product-bag-preparation' }" exact>
            Product Bag Preparation
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'product-bag-receiving' }" exact>
            Product Bag Receiving
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'product-bag-summary' }" exact>
            Product Bag Summary
          </b-link>
        </li>
      </ul>

      <hr v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement', 'Subject Final Status Workflow Editor'])" />
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Lead', 'Epi Lead', 'DSMB', 'fhiClinical', 'SCJ', 'Program PI', 'ND Scientific Director', 'Site PI', 'Notify SAE Acknowledgement', 'Subject Final Status Workflow Editor'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Review Required
          </b-dropdown-header>
        </li>
        <!-- SAE/AE -->
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'serious-adverse-events' }">
            Serious Adverse Events
            <b-badge
              v-if="seriousadverseeventscount > 0"
              variant="danger"
              class="mr-1"
              >{{ seriousadverseeventscount }}</b-badge
            >
            <b-badge
              v-if="otherseriousadverseeventscount > 0"
              variant="warning"
              >{{ otherseriousadverseeventscount }}</b-badge
            >
          </b-link>
        </li>
        <!-- Febrile Withdrawal Requests -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'febrile-withdrawal-request' }">
            Febrile Withdrawal Requests
          </b-link>
        </li>
        <!-- Longitudinal Withdrawal Requests -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'longitudinal-withdrawal-request' }">
            Longitudinal Withdrawal Requests
          </b-link>
        </li>
        <!-- Product Withdrawal Requests -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'product-withdrawal-request' }">
            Product Withdrawal Requests
          </b-link>
        </li>
        <!-- Ento Withdrawal Requests: not ready yet -->
        <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Site PI'])">
          <b-link class="nav-link" :to="{ name: 'ento-withdrawal-request' }">
            Ento Withdrawal Requests
          </b-link>
        </li>
        <!-- Subject Final Status: commented out -->
        <!-- <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])"> -->
        <!-- <li class="nav-item" v-if="inMyGroups(['Subject Final Status Workflow Editor', 'Program PI'])">
          <b-link class="nav-link" :to="{ name: 'subject-final-status' }">
            Subject Final Status Requests -->
            <!-- <b-badge v-if="finalstatuscount > 0" variant="danger" style="margin-right: 5px;">{{
              finalstatuscount
            }}</b-badge> -->
             <!-- <b-badge v-if="finalstatuscompleted > 0 & inMyGroups(['Program PI'])" variant="danger">{{
              finalstatuscompleted
            }}</b-badge> -->
          <!-- </b-link>
        </li> -->
      </ul>

      <!-- Blood Sample Processing -->
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'fhiClinical'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
              Blood Samples
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'blood-sample-receiving' }">
            Blood Sample Receiving
          </b-link>
        </li>
        <!-- disabling IgG iElisa -->
        <!-- <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
            <b-link class="nav-link" :to="{ name: 'igg-elisa-processing' }">
              IgG ELISA Processing
            </b-link>
          </li> -->
        <!-- IgG iElisa -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
          <b-link class="nav-link" :to="{ name: 'upload-igg-elisa' }">
            Upload/View IgG ELISA
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
          <b-link class="nav-link" :to="{ name: 'upload-luminex' }">
            Upload/View Luminex
          </b-link>
        </li>
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
          <b-link class="nav-link" :to="{ name: 'upload-luminex-igm' }">
            Upload/View Final Luminex
          </b-link>
        </li>
        <!-- <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
          <b-link class="nav-link" :to="{ name: 'ielisa-processing' }">
            iELISA Processing
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'frnt-processing' }">
            FRNT Processing
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'rtpcr-processing' }">
            RT PCR Processing
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'igm-elisa-processing' }">
            IgM ELISA Processing
          </b-link>
        </li> -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Epi Lab'])">
          <b-link class="nav-link" :to="{ name: 'blood-sample-review' }">
            Blood Sample Review
          </b-link>
        </li>
      </ul>

      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Ento Data Entry Clerk', 'Ento Lead', 'Site PI', 'fhiClinical'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-tasks"></i>
            Ento Data Entry
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'collection-code-lookup' }" exact>
            Collection Code Lookup
          </b-link>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'new-collection' }" exact>
            Mosquito Data Entry
          </b-link>
        </li>
      </ul>

      <!-- add Epi Data/Random Subject QC -->
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Epi Data
          </b-dropdown-header>
        </li>

        <!-- add Social Sciences/Tips Data -->
        <!-- for now, only Random Subject QC is added -->
        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'Epi Lead', 'Site PI', 'Program PI', 'fhiClinical'])">
          <b-link class="nav-link" :to="{ name: 'random-subjects' }">
            Random Subject QC
          </b-link>
        </li>

        <li class="nav-item" v-if="inMyGroups(['Data Manager', 'fhiClinical'])">
          <b-link
            class="nav-link"
            :to="{ name: 'metrics-subject-enrollment'}"
            exact
          >
            Subject Enrollment Details
          </b-link>
        </li>
      </ul>

      <!-- add Product Replacements here   -->
      <hr v-if="inMyGroups(['Program PI'])">
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Program PI'])">
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Product Data
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'product-replacements' }"
            exact
            v-if="inMyGroups(['Data Manager', 'Program PI'])"
          >
            Product Replacements
          </b-link>
        </li>
      </ul>

      <!-- add Social Sciences/Tips Data and Retail Audit Data -->
      <ul class="nav flex-column" v-if="inMyGroups(['Data Manager', 'Social Science Lead', 'Social Science Manager', 'fhiClinical'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-table"></i>
            Social Sciences
          </b-dropdown-header>
        </li>

        <!-- for Retail Audit Listing Data -->
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'RetailAuditListingForm' } }"
            exact
          >
            Retail Audit Listing Data
          </b-link>
        </li>

        <!-- for Retail Audit Study Data -->
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic-retail-study', query: { view: 'RetailAuditStudyForm' } }"
            exact
          >
            Retail Audit Study Data
          </b-link>
        </li>

        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'tips-data' }"
            exact
            >
            TIPs Data
          </b-link>
        </li>

        <!-- <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'subject-microscopy-template', params: { view: 'details'} }">
            Subject Microscopy Details
          </b-link>
        </li> -->

      </ul>

      <ul class="nav flex-column" v-if="user.is_superuser || inMyGroups(['Data Manager'])">
        <hr />
        <li class="nav-item">
          <b-dropdown-header class="sidebar-heading pl-0 text-aegis-dk">
            <i class="fas fa-users"></i>
            Admin
          </b-dropdown-header>
        </li>
        <li class="nav-item">
          <b-link class="nav-link" :to="{ name: 'users' }">
            Users
          </b-link>
        </li>
        <li class="nav-item">
          <b-link
            class="nav-link"
            :to="{ name: 'generic', query: { view: 'CommcareExportRuns' } }"
            exact
          >
            Export Runs
          </b-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

import SidebarMixin from "@/utilities/slsidebar.js";

export default {
  mixins: [SidebarMixin],
  data() {
    return {
      drawer: true,
      seriousadverseeventscount: 0,
      otherseriousadverseeventscount: 0,
    };
  },
  mounted() {
    // this.getAdverseEventsCount();
    // this.getotherseriousadverseeventscount();

    // Putting it here because this would only be executed if they are logged in.
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("data-jsd-embedded", "");
    recaptchaScript.setAttribute("data-key", "71f002bb-1917-4e79-a426-3806143d541e");
    recaptchaScript.setAttribute("data-base-url", "https://jsd-widget.atlassian.com");
    recaptchaScript.setAttribute("src", "https://jsd-widget.atlassian.com/assets/embed.js");
    document.body.appendChild(recaptchaScript);

    setTimeout(() => {
        var DOMContentLoaded_event = document.createEvent('Event');
        DOMContentLoaded_event.initEvent('DOMContentLoaded', true, true);
        document.dispatchEvent(DOMContentLoaded_event);
    }, 3000);
  },
  computed: {
    ...mapState("user", ["user", "myGroups"]),
    ...mapGetters("user", ['inMyGroups']),
  },
  methods: {
    ...mapActions(["setBaseComponent", "clearAuthorizationToken"]),
    ...mapActions("user", ["setUser"]),
    goTo(route) {
      this.$router.push(route);
    },
    toggle: function() {
      this.drawer = !this.drawer;
    },
    logout: function() {
      this.clearAuthorizationToken();
      this.setUser({});

      this.$notify({
        text: "You have been logged out",
        duration: 10000,
        type: "warn"
      });

      this.$router.push({
        name: "home"
      });
    }
  }
};
</script>

<style>
.sidebar {
  background-color: white;
  box-shadow: inset -1px 0 0 rgba(0, 0, 0, 0.1);
  padding-top: 15px;
  /* height: calc(100vh - 70px); */
  height: 100%;
  /* overflow-y: scroll; */
}
.sidebar .nav-link {
  font-size: 0.9rem;
  font-weight: 400;
  color: #666;
  line-height: 1.3;
  outline: 0;
  padding-left: 2.5rem;
}

.sidebar .nav-link .feather {
  margin-right: 4px;
  color: #999;
}

.sidebar .nav-link.router-link-active {
  color: #333; /* #007bff; */
  font-weight: 500;
  background: #e1eef2;
}

.sidebar .nav-link:hover .feather,
.sidebar .nav-link.active .feather {
  color: inherit;
}

.sidebar-heading {
  font-size: 0.9rem;
  text-transform: uppercase;
  font-weight: 600;
}
</style>
